import React from 'react';
import Navbar from './Navbar';
import './header.css';
const Header = () => {
    return (
        <header  className="Header">
            <h1>Recipes</h1>
            <Navbar/>
        </header>
    )
}

export default Header
